import React, { FC } from 'react'

import { ICONS_NAME, IconV2 } from '..'
import styled from 'styled-components'

import { Color } from '@/utils'

const IconContainerElement = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  cursor: ${({ cursor }) => cursor};
`

const Icon= ({
  icon = ICONS_NAME.add,
  color,
  cursor = 'inherit',
  onClick,
}) =>
  icon ? (
    <IconContainerElement cursor={cursor} onClick={onClick}>
      <IconV2 name={icon} color={color} />
    </IconContainerElement>
  ) : null

export { Icon }
